var Chaplin, config,
  __slice = [].slice;

Chaplin = require('chaplin');

config = require('config');

Handlebars.registerHelper('with', function(context, options) {
  if (!context || Handlebars.Utils.isEmpty(context)) {
    return options.inverse(this);
  } else {
    return options.fn(context);
  }
});

Handlebars.registerHelper('getCoordsLine', function(coords, factor) {
  var resultArray;
  if (factor == null) {
    factor = 1;
  }
  resultArray = [];
  _(coords).each(function(o) {
    resultArray.push(o.x * factor);
    return resultArray.push(o.y * factor);
  });
  resultArray.join(',');
  return resultArray;
});

Handlebars.registerHelper('getURL', function(url, page) {
  if (url) {
    return new Handlebars.SafeString(url);
  }
  return new Handlebars.SafeString("page://" + page);
});

Handlebars.registerHelper('without', function(context, options) {
  var inverse;
  inverse = options.inverse;
  options.inverse = options.fn;
  options.fn = inverse;
  return Handlebars.helpers["with"].call(this, context, options);
});

Handlebars.registerHelper('url', function() {
  var options, params, routeName, _i;
  routeName = arguments[0], params = 3 <= arguments.length ? __slice.call(arguments, 1, _i = arguments.length - 1) : (_i = 1, []), options = arguments[_i++];
  return Chaplin.helpers.reverse(routeName, params);
});

Handlebars.registerHelper('limitLength', function(text, length, tail) {
  var text2;
  if (!text) {
    return;
  }
  text2 = text != null ? text.substr(0, length) : void 0;
  if (length < (text != null ? text.length : void 0)) {
    if (typeof tail !== 'string') {
      tail = '<span class="gray">...</span>';
    }
    text2 += tail;
  }
  return new Handlebars.SafeString(text2);
});

Handlebars.registerHelper('generateThumbList', function(pages) {
  var catalogue, createImg, first, height, i, last, li, page, result, width, _i, _len;
  pages = pages.slice(0);
  catalogue = Chaplin.mediator.catalogue;
  if (pages.length % 2 === 0) {
    last = pages.pop(pages);
  }
  first = pages.shift(pages);
  width = catalogue.get('image_sizes').thumbnail.width;
  height = catalogue.get('image_sizes').thumbnail.height;
  result = [];
  i = 0;
  createImg = function(n) {
    return "<img src='" + config.api.root + "catalogues/" + (catalogue.get('info').folder) + "/page_images/" + n.page_number + "_thumbnail.jpg' width='" + width + "' height='" + height + "'/> ";
  };
  result.push("<li data-page='0,1'>" + (createImg(first)) + "</li>");
  for (i = _i = 0, _len = pages.length; _i < _len; i = _i += 2) {
    page = pages[i];
    li = [];
    li.push(createImg(pages[i]));
    if (pages[i + 1]) {
      li.push(createImg(pages[i + 1]));
    }
    result.push("<li data-page='" + pages[i].page_number + "," + pages[i + 1].page_number + "'>" + (li.join('')) + "</li>");
  }
  if (last) {
    result.push("<li data-page='" + last.page_number + ",0'>" + (createImg(last)) + "</li>");
  }
  return new Handlebars.SafeString(result.join(''));
});

Handlebars.registerHelper('getHeader', function(title) {
  if (title) {
    return title;
  }
  return 'No title';
});

Handlebars.registerHelper('getActualImage', function(pageNumber) {
  return "page_images/" + pageNumber + "_" + (Chaplin.mediator.catalogue.get('image_sizes').actualSize) + ".jpg";
});

Handlebars.registerHelper('filterTag', function(key, body) {
  var skipWords;
  skipWords = ['table'];
  if (_(skipWords).indexOf(key.toLowerCase()) === -1) {
    return new Handlebars.SafeString("<" + key + ">" + body + "</" + key + ">");
  }
  return '';
});

Handlebars.registerHelper('filterLinks', function(type, options) {
  if (type === 'shopping_cart') {
    return options.fn(this);
  }
});

Handlebars.registerHelper('constructImage', function(image) {
  var imagestring;
  imagestring = Chaplin.mediator.catalogue.get('description').imagestring;
  Handlebars.registerHelper('constructImage', function(image) {
    if (_(image).isEmpty()) {
      return '';
    }
    return imagestring.replace('##imageref##', image);
  });
  return Handlebars.helpers.constructImage(image);
});

Handlebars.registerHelper('getProductInfo', function(context, options) {
  var product, _ref;
  product = (_ref = Chaplin.mediator.catalogue.get('description')) != null ? _ref.products[context.link_to_product] : void 0;
  if (!product) {
    product = {
      title: 'No title',
      imageref: '',
      isNoDesc: true
    };
  }
  product.link_to_product = context.link_to_product;
  return options.fn(product);
});
